const roles = [
    {
        id: '7C7B996C-732E-4621-9F21-7EC3C0709A63',
        name: 'System',
        rank: 0,
    },
    {
        id: '5AC1F34D-63C1-4930-89FF-BEB6B652B9E8',
        name: 'System Administrator',
        rank: 10,
    },
    {
        id: '786940DF-ECC8-4165-99E2-6F100099873D',
        name: 'Global Operator',
        rank: 20,
    },
    {
        id: '16E92A99-0260-45DF-B28D-F3FCBB124D4A',
        name: 'Company Administrator',
        rank: 30,
    },
    {
        id: 'FD74D086-85C9-4492-BCC6-3B079CD71D30',
        name: 'Manager',
        rank: 50,
    },
    {
        id: 'F10C7002-AAAF-45EF-B8F9-FCBB3BBFD1FB',
        name: 'Employee',
        rank: 60,
    },
]

const state = {
    roles: roles,
}

const getters = {
    roles: state => state.roles,
    roleList: state => state.roles,
}

export default {
    namespaced: true,
    state,
    getters,
}
